import Component from "react-pure-render/component";
import React from "react";
import immutable from "immutable";
import "./pagination.css";

export default class PaginationItem extends Component {
  static propTypes = {
    number: React.PropTypes.number.isRequired
  };

  constructor() {
    super();
  }

  setPage = () => {
    const { number, action } = this.props;
    action(number - 1);
  };

  render() {
    const { number, active } = this.props;

    return (
      <div
        onClick={this.setPage}
        className={active ? "page-number active" : "page-number"}
      >
        {number}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/browser/components/pagination/paginationItem.react.js